import React from 'react';
import { Link } from 'react-router-dom';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
import { telHref } from '../../utils/format';
export function Footer() {
  const {
    settings
  } = useAdminData();
  return <footer className="border-t border-line bg-canvas-deep" data-id="element-171" data-mp="2wi9x2oazsy1l">
      <div className="mx-auto max-w-content px-5 py-12 lg:px-8" data-id="element-172" data-mp="31fjxt03u0w4q">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between" data-id="element-173" data-mp="3p42x4q4wlyko">
          <div data-id="element-174" data-mp="3u3pglhbbsb1x">
            <img src={company.logoWide} alt={settings.companyName} className="h-12 w-auto md:h-14" data-id="element-175" data-mp="3u47boam94j89" />
            <p className="mt-4 text-[15px] text-ink-soft" data-id="element-176" data-mp="3ffb40eo3x886">{settings.tagline}</p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-177" data-mp="3kdw50gb6nvxo">CVR: {settings.cvr}</p>
          </div>

          <div className="flex flex-col gap-2 text-[15px] md:items-end" data-id="element-178" data-mp="by2t6ersr8my">
            <a href={telHref(settings.phone)} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-179" data-mp="bwrkq1nepcpi">
              {settings.phone}
            </a>
            <a href={`mailto:${settings.email}`} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-180" data-mp="3jd896jwztfoz">
              {settings.email}
            </a>
            <div className="mt-3 flex gap-5 text-sm text-ink-muted" data-id="element-181" data-mp="3nhfzglj3n3pb">
              <a href="#kontakt" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-182" data-mp="3nf3edzi1od81">
                Kontakt
              </a>
              <a href="#privatliv" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-183" data-mp="12eilagvce2h">
                Privatlivspolitik
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-line pt-6 text-sm text-ink-muted" data-id="element-184" data-mp="b0uc1k3dbzf5">
          <p data-id="element-185" data-mp="2gt11csjkl3zc">
            © {new Date().getFullYear()} {settings.companyName}
          </p>
          <Link to="/admin/login" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-186" data-mp="2csqmsrhpp58v">
            Admin
          </Link>
        </div>
      </div>
    </footer>;
}